import {
  GET_INVENTORY_FEATURE_FLAG,
  SET_INVENTORY_FEATURE_FLAG,
  HANDLE_ACCESS_BUSINESS_LIBRARY,
} from './types';

/**
 * Fetch feature flags from service.
 * @return {[array]}
 */
export function getInventoryFeatureFlag() {
  return { type: GET_INVENTORY_FEATURE_FLAG };
}

export function setInvetoryFeatures(features) {
  return {
    type: SET_INVENTORY_FEATURE_FLAG,
    payload: features,
  };
}

export function handleAccessBusinessLibrary() {
  return { type: HANDLE_ACCESS_BUSINESS_LIBRARY };
}
